import http, { httpGet } from '@/utils/http';

export default {
	previewSortingWord: data => {
		return http({ url: '/api/admin/v1/sorting/previewSortingWord', data}).then(r => r);
	},
	saveSortingWord: data => {
		return http({ url: '/api/admin/v1/sorting/saveSortingWord', data, tip: true }).then(r => r);
	},
	// V2 API
	list: data => {
		return http({ url: '/api/admin/v2/sorting/list', data }).then(r => r);
	},
	getStoreDetails: data => {
		return http({ url: '/api/admin/v2/sorting/getStoreDetails', data }).then(r => r);
	},
    printSorting: data => {
        return http({ url: '/api/admin/v2/sorting/printSorting', data, tip: true }).then(r => r);
    },
	completeSorting: data => {
		return http({ url: '/api/admin/v2/sorting/completeSorting', data, tip: true }).then(r => r);
	},
	updateStoreSortingCount: data => {
		return http({ url: '/api/admin/v2/sorting/updateStoreSortingCount', data, tip: true }).then(r => r);
	},
	generateSortingWithSync: data => {
		return http({ url: '/api/admin/v2/sorting/generateSortingWithSync', data }).then(r => r);
	},
	getGenerateProgress: (taskId) => {
		return httpGet({ 
			url: '/api/admin/v2/sorting/getGenerateProgress', 
			params: { task_id: taskId } 
		}).then(r => r);
	},
	// V3 API
	generateSorting: data => {
		return http({ url: '/api/admin/v3/sorting/generateSorting', data, tip: true, loading: true }).then(r => r);
	},
	// V3 异步生成分拣单（带进度条）
	generateSortingAsync: data => {
		return http({ url: '/api/admin/v3/sorting/generateSortingAsync', data }).then(r => r);
	},
	// V1 API (保留用于旧功能)
	previewSortingWordFromEntryWords: data => {
		return http({ url: '/api/admin/v1/sorting/previewSortingWordFromEntryWords', data }).then(r => r);
	},
	generateSortingWordWithSync: data => {
		return http({ url: '/api/admin/v1/sorting/generateSortingWordWithSync', data }).then(r => r);
	},
};

